<template>
    <div>
        <Title>基本信息</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.projectName }}</div>

            <div class="label">项目编号</div>
            <div class="value1">{{ extra.projectCode }}</div>
            <div class="label">设计编号</div>
            <div class="value2">{{ extra.designCode }}</div>

            <div class="label">管理级别</div>
            <div class="value1">
                <DataDictFinder dictType="cosys.manageLevel" :dictValue="extra.manageLevel" />
            </div>
            <div class="label">阶段</div>
            <div class="value2">
                <DataDictFinder dictType="cosys.designPhase" :dictValue="extra.phaseCode" />
            </div>

            <div class="label">版本</div>
            <div class="value1">{{ extra.planVersion }}</div>

            <div class="label">要求完成日期</div>
            <div class="value2">{{ extra.requireFinishDate | date }}</div>
            <div class="label">参与专业</div>
            <div class="value3">
                <DataDictFinder dictType="cosys.major" :dictValue="extra.majors" />
            </div>


        </div>
        <Title>项目成员</Title>
        <div class="panel">
            <div class="label">项目负责人</div>
            <div class="value1">{{ extra.prjLeaderName }}</div>
            <div class="label">项目分管总工</div>
            <div class="value2">{{ extra.chiefEngineerName }}</div>

            <div class="label">部门分管负责人</div>
            <div class="value1">{{ extra.deptLeaderName }}</div>
            <div class="label">总工</div>
            <div class="value2">{{ extra.generalEngineerName }}</div>

            <div class="label">批准人</div>
            <div class="value1">{{ extra.approverName }}</div>
            <div class="label">公司分管领导</div>
            <div class="value2">{{ extra.companyLeaderName }}</div>

            <div class="label">配合部门</div>
            <div class="value1">{{ extra.cooperateDeptNames }}</div>
            <div class="label">项目负责部门</div>
            <div class="value2">{{ extra.prjLeaderDeptName }}</div>

        </div>
        <div class="specVicePresident">
            <div class="hint">
                <span class="hintTitle">总工</span><span class="hintName">-院管项目填公司总工，所管项目填部门总工；</span>
                <span class="hintTitle">项目分管总工</span><span class="hintName">-院管项目填公司专业副总，所管项目填部门副总工或总工，分管总工为主专业审定人。</span>
            </div>
            <div class="hint">
                <span class="hintTitle">公司分管领导</span><span class="hintName">-院管项目填写项目所属区域负责人；</span>
                <span class="hintTitle">配合部门</span><span class="hintName">-项目组成员中有其他部门人员，需该部门负责人会签。</span>
            </div>
            <div class="hint">
                <span class="hintName">公司管项目（总院）所有专业需签到审定</span>
            </div>
        </div>
        <Title>专业信息</Title>
        <div>
            <a-table
                :columns="majorColumns"
                :data-source="extra.majorsDetail || []"
                :row-key="(record, index) => record.id || record.majorCode || index"
                :pagination="false"
                bordered
            />
        </div>

        <Title>子项信息</Title>
        <div>
            <a-table
                :columns="subItemColumns"
                :data-source="extra.subItems || []"
                :row-key="(record, index) => record.id || record.subCode || `sub_${index}`"
                :pagination="false"
                bordered
            />
        </div>

        <Title>子项专业人员信息</Title>
        <div>
            <a-table
                :columns="subMajorColumns"
                :data-source="extra.subMajors || []"
                :row-key="(record, index) => record.id || `${record.subCode}_${record.majorCode}` || `sm_${index}`"
                :pagination="false"
                bordered
            />
        </div>
        <Title>详细信息</Title>
        <div class="panel">
            <div class="label">设计评审方式</div>
            <div class="value1">会议式</div>
            <div class="label">设计评审日期</div>
            <div class="value2">{{ extra.designReviewDate | date }}</div>

            <div class="label">设计输入下达时间</div>
            <div class="value1">{{ extra.designInputDate | date }}</div>
            <div class="label">出图日期</div>
            <div class="value2">{{ extra.drawingDate | date }}</div>
            <div class="label">归档时间</div>
            <div class="value3">{{ extra.requireFinishDate | date }}</div>
        </div>
        <div class="specVicePresident">
            <div class="hint">
                <span class="hintName">时间先后顺序：设计输入下达-设计评审-出图-归档</span>
            </div>
        </div>
        <div class="panel">
            <div class="label">专业提资时间</div>
            <div class="value3">{{ extra.majorSubmitDate }}</div>
            <div class="label">所需特殊装备及设施</div>
            <div class="value3">{{ extra.specialEquipment }}</div>
            <div class="label">要达到的质量目标及要求</div>
            <div class="value3">{{ extra.qualityTarget }}</div>
        </div>
        <div class="specVicePresident">
            <div class="hint">
                <span class="hintTitle">其他：1、互提资料贯穿于设计全过程，按设计进度适时开展；2、设计验证活动贯穿于设计全过程，按设计进度适时开展；</span>
            </div>
        </div>
        <div class="panel">
            <div class="label full-label">备注</div>
            <div class="value4">{{ extra.remark }}</div>

            <div class="label">附件</div>
            <div class="value3">
                <template v-if="extra.attachment">
                    <div v-for="(item, index) in attachmentList" :key="index">
                        <a :href="item.url" @click.prevent="handleFileClick($event, item.url, item.name)">{{ item.name }}</a>
                    </div>
                </template>
            </div>
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Title from "../Title";
export default {
    components: {
        Title,
    },
    computed: {
        ...mapState("approval", ["detail"]),
        ...mapGetters("setting", ["findDataDict"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        majorColumns() {
            const majorDict = this.findDataDict("cosys.major") || [];
            return [
                { title: "专业", dataIndex: "majorCode", key: "majorName", width: 80, customRender: (code) => { const item = majorDict.find(d => d.value === code); return item ? item.name : code; } },
                { title: "专业代码", dataIndex: "majorCode", key: "majorCode", width: 80, customRender: (code) => { const item = majorDict.find(d => d.value === code); return item ? `${code}` : code; } },
                { title: "专业负责人", dataIndex: "majorLeaderNames", key: "majorLeaderNames", width: 120 },
                { title: "设计人", dataIndex: "designerNames", key: "designerNames", width: 120 },
                { title: "复核人", dataIndex: "reviewerNames", key: "reviewerNames", width: 120 },
                { title: "审核人", dataIndex: "auditorNames", key: "auditorNames", width: 120 },
                { title: "审定人", dataIndex: "approverNames", key: "approverNames", width: 120 },
                { title: "备注", dataIndex: "remark", key: "remark", width: 120 },
            ];
        },
        subMajorColumns() {
            const majorDict = this.findDataDict("cosys.major") || [];
            return [
                { title: "子项名称", dataIndex: "subName", key: "subName", width: 120 },
                { title: "子项编号", dataIndex: "subCode", key: "subCode", width: 80 },
                { title: "专业名称", dataIndex: "majorCode", key: "majorName", width: 80, customRender: (code) => { const item = majorDict.find(d => d.value === code); return item ? item.name : code; } },
                { title: "专业编号", dataIndex: "majorCode", key: "majorCode", width: 80, customRender: (code) => { const item = majorDict.find(d => d.value === code); return item ? `${code}` : code; } },
                { title: "设计人", dataIndex: "designerNames", key: "designerNames", width: 120 },
                { title: "复核人", dataIndex: "reviewerNames", key: "reviewerNames", width: 120 },
                { title: "审核人", dataIndex: "auditorNames", key: "auditorNames", width: 120 },
                { title: "审定人", dataIndex: "approverNames", key: "approverNames", width: 120 },
            ];
        },
        subItemColumns() {
            const majorDict = this.findDataDict("cosys.major") || [];
            return [
                { title: "子项编号", dataIndex: "subCode", key: "subCode", width: 80 },
                { title: "子项名称", dataIndex: "subName", key: "subName", width: 160 },
                { title: "参与专业", dataIndex: "majors", key: "majors", width: 120, customRender: (codes) => { if (!codes) return '-'; return codes.split(',').map(c => { const item = majorDict.find(d => d.value === c); return item ? item.name : c; }).join(', '); } },
                { title: "子项负责人", dataIndex: "subLeaderName", key: "subLeaderName", width: 120 },
                { title: "计划完成日期", dataIndex: "planEndDate", key: "planEndDate", width: 120, customRender: (text) => text ? new Date(text).toLocaleDateString() : '-' },
                { title: "备注", dataIndex: "remark", key: "remark", width: 120 },
            ];
        },
        attachmentList() {
            if (!this.extra.attachment) return [];
            return this.extra.attachment.split(",").filter(Boolean).map(url => {
                let name;
                try {
                    name = decodeURIComponent(this.$getFileName(url));
                } catch (e) {
                    name = this.$getFileName(url);
                }
                return { url, name };
            });
        },
    },
    methods: {
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        deepDecodeURIComponent(str) {
            // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
            // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
            // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
            let decoded = str;
            while (decoded.includes('%25')) {
                const prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
                if (decoded === prev) break;
            }
            return decoded;
        },
        handleFileClick(event, url, filename) {
            event.preventDefault();
            const decodedUrl = this.deepDecodeURIComponent(url);
            if (this.isPdfFile(filename)) {
                this.previewPdf(decodedUrl, filename);
            } else {
                const a = document.createElement('a');
                a.href = decodedUrl;
                a.download = filename || '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        },
    },
    filters: {
        date(val) {
            if (!val) return '-';
            return new Date(val).toLocaleDateString();
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .full-label {
        grid-column-start: 1;
        grid-column-end: 2;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value4 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

}
.specVicePresident {
    text-align: center;
    margin: 15px 0;
}

.hintInit {
    margin: 10px 0;
    margin-left: 5%;
}

.hint {
    font-size: 12px;
    color: #999;
    line-height: 1.6;
    margin-top: 2px;
    padding-left: 8px;
}

.hintName {
    color: red;
    height: 25px;
    white-space: nowrap;
}

.hintTitle {
    color: #000c17;
}

.hintText {
    margin-top: -10px !important;
    height: 25px !important;
}
</style>
